var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"adsdsdfss",style:({ height:( _vm.height ? _vm.height : 260) + 'px',marginBottom:( _vm.mb ? _vm.mb : 16)+'px' })},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"sedewrtf",style:({ background: _vm.bg ? _vm.bg : '#fff' })},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b341f5c8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!../common/src/components/lykanbanbox.vue
// module id = null
// module chunks = 